export default __webpack_public_path__ + "static/mathieu_henri-8c0ee726ea78eeb96ca21cf0f0aa2fc9.png";